import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useHistory } from 'react-router';
import Routes from 'routes';
import {
  ContainerBox,
  ReportActionButton,
} from './ReportActionButtons.style-elements';

interface Labels {
  [key: string]: string;
}

interface ReportActionButtonsProps {
  buttonLabels: Labels;
}

const ReportActionButtons: React.FC<ReportActionButtonsProps> = ({
  buttonLabels,
}) => {
  const history = useHistory();
  return (
    <ContainerBox>
      <ReportActionButton
        variant="contained"
        color="primary"
        startIcon={<CloudDownloadIcon />}
        onClick={(): void => history.push(Routes.REPORT_MODAL_EXPORT)}
      >
        {buttonLabels.export}
      </ReportActionButton>
      <ReportActionButton
        color="primary"
        startIcon={<DeleteIcon />}
        onClick={(): void => history.push(Routes.REPORT_MODAL_DELETE)}
      >
        {buttonLabels.delete}
      </ReportActionButton>
    </ContainerBox>
  );
};

export default ReportActionButtons;
